import React from "react";
import { useLocation } from "react-router-dom";

const PaymentFailed = () => {
  const location = useLocation();
  const error = new URLSearchParams(location.search).get("error");
  const cancel = new URLSearchParams(location.search).get("cancel");

  if (!error) {
    window.location.href = "/";
  }
  return (
    <div
      className="d-flex flex-column align-items-center justify-content-center"
      style={{ height: "50vh" }}
    >
      <h2>Payment {cancel ? "Cancelled" : "Failed"}</h2>
      <p>There was an error processing your payment.</p>
    </div>
  );
};

export default PaymentFailed;
